export default __webpack_public_path__ + "static/media/G0890_PPH_massage.1702984680000.37b8acff.jpg";